import { fromZonedTime, toZonedTime } from 'date-fns-tz';

/**
 * Converts a UTC instant to a Date whose browser-local wall clock shows the
 * time in the calendar's time zone. Offsets are resolved at the event's date,
 * so dates on the other side of a DST change are converted correctly.
 * A missing time zone means the browser's time zone (identity).
 */
export function utcToCalendarWallTime(date: Date, timeZone: string | null | undefined): Date {
  return timeZone ? toZonedTime(date, timeZone) : date;
}

/**
 * Inverse of {@link utcToCalendarWallTime}: interprets the Date's browser-local
 * wall clock as a time in the calendar's time zone and returns the UTC instant.
 */
export function calendarWallTimeToUtc(date: Date, timeZone: string | null | undefined): Date {
  return timeZone ? fromZonedTime(date, timeZone) : date;
}

/**
 * Shifts a UTC instant between calendar time zones so the wall-clock time is
 * preserved (2 PM in the source zone stays 2 PM in the target zone).
 */
export function shiftUtcBetweenCalendarTimezones(
  date: Date,
  fromTimeZone: string | null | undefined,
  toTimeZone: string | null | undefined,
): Date {
  return calendarWallTimeToUtc(utcToCalendarWallTime(date, fromTimeZone), toTimeZone);
}
